module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("I would like to dedicate this book to a number of people, with the first being my mum, who always encouraged me to use my imagination. The second dedication goes to my sister, Debbie. When we were younger, we spent many hours making up silly stories and inventing characters, one of which was the ‘Karillapig’. We were not completely alone in this, which brings me to my next dedication – thank you, Mick Burrows, for encouraging the silly…A special dedication also goes to, Lewis Clough, who allowed me to use his bedroom in the book. Lewis Clough, you are indeed a true super-hero. The final dedication goes to my fabulous dad, known to many as Rusty. Though, you are no longer with us, you continue to inspire me every single day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0